// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"SubCategories_scrollable__KeW0n"};